export default "__VITE_PUBLIC_ASSET__bb5a8509__"